import { IState } from '../../store';
import { selectOffer } from '../offerData';

export const selectHasDiscountMortgage = (state: IState): boolean => {
  const { hasDiscountMortgage } = selectOffer(state);

  return Boolean(hasDiscountMortgage);
};
